<template>
  <img
    src="/HendrixIndustriesLogoRM4C.png"
    alt="Hendrix Industries"
    style="height:36px;width:auto;display:block;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
